import { useParams } from "react-router-dom";
import { useContext, useMemo } from "react";
import { ProdutosContext } from "../../../shared/contexts/ProdutosContext";
import { CategoriasContext } from "../../../shared/contexts/CategoriasContext";
import FooterOpcoes from '../components/FooterOpcoes';
import CardItem from '../components/CardItem';
import styles from "./PageCategorias.module.css";

function PageCategorias() {
  const { id } = useParams();
  const { produtos } = useContext(ProdutosContext);
  const { categorias } = useContext(CategoriasContext);

  const idNum = Number(id);

  const categoriaAtual = categorias.find(
    (categoria) => Number(categoria.id_categoria) === idNum
  );

  const produtosFiltrados = useMemo(
    () => produtos.filter((produto) =>
      Number(produto.id_categoria) === idNum && produto.disponivel?.toLowerCase() === "sim"
    ),
    [produtos, idNum]
  );

  const adicionarAoCarrinho = (item) => {
    let carrinho = JSON.parse(localStorage.getItem("carrinho")) || [];
    const itemComIdUnico = { ...item, uuid: Date.now() + Math.random() };
    carrinho.push(itemComIdUnico);
    localStorage.setItem("carrinho", JSON.stringify(carrinho));

    // Salvar o estabelecimento_id no localStorage
    if (item.id_estabelecimento) {
      localStorage.setItem('estabelecimento_id', item.id_estabelecimento);
      console.log('✅ [CARRINHO] estabelecimento_id salvo no localStorage:', item.id_estabelecimento);
      // Disparar evento para conectar SSE
      window.dispatchEvent(new CustomEvent('estabelecimentoChanged', {
        detail: { estabelecimentoId: item.id_estabelecimento }
      }));
    }

    // Disparar evento para atualizar o contador do carrinho
    window.dispatchEvent(new Event("carrinhoAtualizado"));

    alert(`${item.label_title} foi adicionado ao carrinho!`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.tituloContainer}>
          <h1 className={styles.tituloCategoria}>
            {categoriaAtual ? categoriaAtual.nome_categoria : "Categoria"}
          </h1>
          <p className={styles.totalProdutos}>
            {produtosFiltrados.length} {produtosFiltrados.length === 1 ? 'produto' : 'produtos'}
          </p>
        </div>
      </div>

      {produtosFiltrados.length > 0 ? (
        <div className={styles.listaProdutos}>
          {produtosFiltrados.map((produto) => (
            <CardItem
              key={produto.id_item}
              id_item={produto.id_item}
              src={produto.imagem}
              label_title={produto.nome_item}
              p_descricao={produto.descricao}
              p_preco={`R$ ${parseFloat(produto.preco).toFixed(2)}`}
              id_estabelecimento={produto.id_estabelecimento}
              adicionarAoCarrinho={adicionarAoCarrinho}
              quantidade={produto.quantidade}
              hideAddBtn
            />
          ))}
        </div>
      ) : (
        <div className={styles.semProdutosContainer}>
          <div className={styles.semProdutosIcone}>📦</div>
          <p className={styles.semProdutos}>
            Nenhum produto encontrado nesta categoria.
          </p>
        </div>
      )}

      <FooterOpcoes typeView="cliente"/>
    </div>
  );
}

export default PageCategorias;
